/**
 * Learning Supports / IEP prompts — shared pieces.
 * Vision extraction prompt is in LearningSupportsVisionPrompt.js
 * Each AI-generation prompt is in its own file: Prompts_MEASURABLE_GOALS_SYSTEM.js, Prompts_SUPPORTS_SERVICES_SYSTEM.js, etc.
 */
export const VISION_EXTRACTION_TAIL = `
 
Now carefully read the document images and extract + map answers.

`;
